module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAABJ0AAASdAHeZh94AAABS0lEQVQ4ja3Tv0tbURTA8c97PiguguBQm8luktUfFezQTt2qm52EqlungpuLQotIZmnpVCh00H+hBZF20L1jQXDJZMUWIWDikHfJS31JXky+y+Ny7v2ec+67J5rbv5BhCe8xjjpinOMVrnGAqUzsEtv4GgRJRjaJT5jQzkM8xT8s5MQ+4CfOpFkCOzmyQANRh9gYdsMiCBfxusOBIGx0ia/gRRAmqPxX7X2oYDTGG8z32BwXSFjGZoKNAtmv8LfAvtUE63gu/9IjVHGYrtdQkn+fDRwnOMUf3Vt6kn5POsiC8HeSZn/ZRdYP32PMDEkG5Ri1IQpr2dH7hS+40fpBy3o/qTaywiqONAc/MDuI8Bl+9HM4j0HH7Q7ZCr9hS7Pl7COv4zE+40ERYajykebE5AlLGClQYJRovfxpvCtwqBtxgj28VaCdHtTw8RZZzDoaNxkBpgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/库存管理B.png
// module id = Bg5u
// module chunks = 2